export const ESTIMATE_OPTIONS = [
  { label: "Draft", value: "Draft" },
  { label: "Submitted", value: "Submitted" },
  { label: "Approved", value: "Approved" },
  { label: "Declined", value: "Declined" },
  { label: "Inactive", value: "Inactive" },
];

// header-actions.utils.js
export const getTimelinesMenuOptions = ({
  isGeneralUser,
  exportEstimate,
  exportTimeline,
  exportGantt,
  exportSimpleEstimate,
  exportSimpleTimeline,
  handleSaveAsTemplate,
  plannerType,
}) => {
  // General users only get “Save as Template”
  if (isGeneralUser) {
    return [{ title: "Save as Template", onClick: handleSaveAsTemplate }];
  }

  // “Materials” plans get only the normal estimate
  if (plannerType === "Materials") {
    return [{ title: "Detailed Estimate PDF", onClick: exportEstimate }];
  }

  // Fixed Fee Project plans get Estimate + Save-as-Template only
  if (plannerType === "Fixed Fee Project") {
    return [
      { title: "Estimate PDF", onClick: exportEstimate },
      { title: "Save as Template", onClick: handleSaveAsTemplate },
    ];
  }

  // Time + Materials: inject your two “simple” exports first
  if (plannerType === "Time + Materials") {
    return [
      { title: "Simple Estimate PDF", onClick: exportSimpleEstimate },
      { title: "Detailed Estimate PDF", onClick: exportEstimate },
      { title: "Simple Timeline PDF", onClick: exportSimpleTimeline },
      { title: "Detailed Timeline PDF", onClick: exportTimeline },
      // { title: "Gantt PDF", onClick: exportGantt },
      { title: "Save as Template", onClick: handleSaveAsTemplate },
    ];
  }

  // All other planner types (e.g. Fixed Fee Deliverable)
  return [
    { title: "Estimate PDF", onClick: exportEstimate },
    { title: "Timeline PDF", onClick: exportTimeline },
    // { title: "Gantt PDF", onClick: exportGantt },
    { title: "Save as Template", onClick: handleSaveAsTemplate },
  ];
};

export const validDeliverables = (completeProject) => {
  return completeProject.builderData?.deliverables?.some(
    (deliverable) =>
      deliverable.name.trim() !== "" &&
      deliverable.tasks?.some(
        (task) =>
          task.name.trim() !== "" &&
          task.resources?.some((resource) => resource.isEnabled)
      )
  );
};
